import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LOGO_URL } from "../data/brand";
import { useAuth } from "../context/AuthContext";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/annunci", label: "Annunci" },
  { to: "/categorie", label: "Categorie" },
  { to: "/prezzi", label: "Prezzi" },
  { to: "/contatti", label: "Contatti" },
];

export default function Navbar() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  return (
    <header className="glass-nav sticky top-0 z-50" data-testid="main-navbar">
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo-link">
          <img src={LOGO_URL} alt="HostMarket" className="h-8 w-auto" />
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} className="text-sm text-zinc-300 hover:text-[#FFBE00] transition-colors" data-testid={`nav-${n.label.toLowerCase()}`}>
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {!user && (
            <>
              <Link to="/login" className="text-sm text-zinc-300 hover:text-white" data-testid="nav-login">Accedi</Link>
              <Link to="/registrati" className="px-4 py-2 rounded-md bg-[#FFBE00] text-black text-xs font-bold uppercase tracking-wider hover:bg-[#E619A8] hover:text-white transition-all" data-testid="nav-register">
                Pubblica annuncio
              </Link>
            </>
          )}
          {user && (
            <>
              <Link to="/dashboard" className="text-sm text-zinc-300 hover:text-white" data-testid="nav-dashboard">Dashboard</Link>
              {user.role === "admin" && (
                <Link to="/admin" className="text-sm text-[#E619A8] hover:text-[#FFBE00]" data-testid="nav-admin">Admin</Link>
              )}
              <button
                onClick={() => { logout(); nav("/"); }}
                className="text-sm text-zinc-400 hover:text-white"
                data-testid="nav-logout"
              >
                Esci
              </button>
            </>
          )}
        </div>
        <button className="md:hidden text-white" onClick={() => setOpen(!open)} data-testid="navbar-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-zinc-800 bg-black" data-testid="navbar-mobile-menu">
          <div className="flex flex-col px-4 py-4 gap-3">
            {NAV.map((n) => (
              <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="text-zinc-200">{n.label}</Link>
            ))}
            {!user ? (
              <>
                <Link to="/login" onClick={() => setOpen(false)} className="text-zinc-200">Accedi</Link>
                <Link to="/registrati" onClick={() => setOpen(false)} className="px-4 py-2 rounded-md bg-[#FFBE00] text-black font-bold uppercase text-xs w-fit">Pubblica annuncio</Link>
              </>
            ) : (
              <>
                <Link to="/dashboard" onClick={() => setOpen(false)} className="text-zinc-200">Dashboard</Link>
                {user.role === "admin" && <Link to="/admin" onClick={() => setOpen(false)} className="text-[#E619A8]">Admin</Link>}
                <button onClick={() => { logout(); setOpen(false); nav("/"); }} className="text-left text-zinc-400">Esci</button>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
